/* VCTparts delivery info block (snippets/henk-levertijden-dynamisch.liquid).
   Moved out of the snippet so the browser caches it; texts come from the
   #vct-info-i18n JSON. */
(function () {
  const FREE_SHIPPING_THRESHOLD = 3900;

  // Vertalingen (uit het JSON-blok hierboven); valt terug op Nederlands
  let T = {};
  try { T = JSON.parse(document.getElementById('vct-info-i18n').textContent); } catch (e) {}
  const localeEl = document.querySelector('.vct-info-block');
  const LOCALE = (localeEl && localeEl.getAttribute('data-vct-locale')) || 'nl-NL';
  function tpl(str, vars) { return String(str || '').replace(/%\{(\w+)\}/g, function (_, k) { return vars[k] != null ? vars[k] : ''; }); }

  // Pijl-icoon uit snippets/vct-icon.liquid (arrow-right)
  const ARROW = '<svg class="vct-icon vct-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';

  function getNextWeekday(date) {
    let d = new Date(date);
    d.setDate(d.getDate() + 1);
    if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    try { return d.toLocaleDateString(LOCALE, { weekday: 'long' }); } catch (e) { return d.toLocaleDateString('nl-NL', { weekday: 'long' }); }
  }

  function setShippingMessages() {
    const nodes = document.querySelectorAll('.vct-shipping-message');
    if (!nodes.length) return;
    const nu = new Date();
    const dag = nu.getDay();
    const uur = nu.getHours();
    let tijdTekst, dagTekst;
    if (dag >= 1 && dag <= 5 && uur < 20) {
      tijdTekst = "20:00"; dagTekst = T.today || "vandaag";
    } else if (dag >= 1 && dag <= 4 && uur >= 20) {
      tijdTekst = "23:59"; dagTekst = getNextWeekday(nu);
    } else if ((dag === 5 && uur >= 20) || dag === 6 || dag === 0) {
      tijdTekst = "23:59"; dagTekst = T.monday || "maandag";
    } else {
      tijdTekst = "23:59"; dagTekst = T.tomorrow || "morgen";
    }
    nodes.forEach(function (el) {
      const block = el.closest('[data-vct-variant]');
      const freeShippingText = block && block.dataset.vctFree ? block.dataset.vctFree : "";
      const verzending = freeShippingText ? (T.shippedFree || "<strong>gratis</strong> verzonden") : (T.shipped != null ? T.shipped : "verzonden");
      el.innerHTML = tpl(T.orderBefore || "Besteld voor <strong>%{time}</strong> %{arrow} <span class='vct-promise'>%{day} %{shipped}</span>", { time: tijdTekst, day: dagTekst, shipped: verzending, arrow: ARROW });
    });
  }

  function startTimer() {
    const badges = document.querySelectorAll('.vct-countdown-badge');
    if (!badges.length) return;
    function update() {
      const now = new Date();
      const dag = now.getDay();
      const uur = now.getHours();
      const actief = dag >= 1 && dag <= 5 && uur < 20;
      const cutoff = new Date();
      cutoff.setHours(20, 0, 0, 0);
      const diff = cutoff - now;
      badges.forEach(function (badge) {
        if (!actief || diff <= 0) { badge.style.display = "none"; return; }
        badge.style.display = "flex";
        const timerEl = badge.querySelector('.vct-timer');
        if (!timerEl) return;
        const h = Math.floor(diff / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        timerEl.textContent =
          String(h).padStart(2,'0') + ":" +
          String(m).padStart(2,'0') + ":" +
          String(s).padStart(2,'0');
      });
    }
    update();
    setInterval(update, 1000);
  }

  function currentVariantId() {
    // Prefer the main product form: its variant input sits outside the <form> (form="main-product-form-…")
    const input = document.querySelector('[name="id"][form^="main-product-form"]')
      || document.querySelector('form[id^="main-product-form"] [name="id"]')
      || document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return String(input.value);
    const param = new URLSearchParams(window.location.search).get('variant');
    return param ? String(param) : null;
  }

  function showVariant(id) {
    const blocks = document.querySelectorAll('[data-vct-variant]');
    if (!blocks.length) return;
    let found = false;
    blocks.forEach(function (b) {
      const match = b.dataset.vctVariant === id;
      if (match) found = true;
      b.hidden = !match;
    });
    if (!found) blocks[0].hidden = false;
    setShippingMessages();
  }

  let lastVariantId = null;
  function syncVariant() {
    const id = currentVariantId();
    if (id && id !== lastVariantId) {
      lastVariantId = id;
      showVariant(id);
    }
  }

  function updateThreshold() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const titleEl      = document.getElementById("vct-threshold-title");
        const subEl        = document.getElementById("vct-threshold-sub");
        const progressWrap = document.getElementById("vct-progress-wrap");
        const progressFill = document.getElementById("vct-progress-fill");
        const truckWrap    = document.querySelector('.vct-icon-wrap--truck');
        if (!titleEl) return;
        const cartTotal = cart.total_price;
        const missing   = FREE_SHIPPING_THRESHOLD - cartTotal;
        const pct       = Math.min(100, Math.round((cartTotal / FREE_SHIPPING_THRESHOLD) * 100));
        if (missing <= 0) {
          titleEl.innerHTML = '<span class="vct-text-success">' + (T.freeTitle || "Gratis verzending van toepassing!") + '</span>';
          subEl.innerHTML   = T.freeSub || "Je bestelling wordt gratis verzonden";
          progressWrap.style.display = "none";
          if (truckWrap) truckWrap.classList.add('vct-icon-wrap--free');
        } else {
          const missingFormatted = (missing / 100).toFixed(2).replace('.', ',');
          titleEl.innerHTML = tpl(T.missing || "Nog <strong>€%{amount}</strong> voor gratis verzending", { amount: missingFormatted });
          subEl.innerHTML   = T.freeFrom || "Gratis verzending vanaf 39,-";
          progressWrap.style.display = "block";
          progressFill.style.width   = pct + "%";
          if (truckWrap) truckWrap.classList.remove('vct-icon-wrap--free');
        }
      })
      .catch(function () {
        // Winkelwagen niet op te halen: toon de vaste drempel in plaats van "Laden..."
        const titleEl = document.getElementById("vct-threshold-title");
        if (titleEl && titleEl.querySelector('.vct-row-loading')) titleEl.innerHTML = T.freeFrom || "Gratis verzending vanaf 39,-";
      });
  }

  function init() {
    setShippingMessages();
    startTimer();
    updateThreshold();
    lastVariantId = currentVariantId();
    setInterval(syncVariant, 400);
    window.addEventListener('popstate', syncVariant);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') syncVariant();
    });
    document.addEventListener('cart:updated', updateThreshold);
    const cartCount = document.querySelector('[data-cart-count], .cart-count, #cart-count, .cart__count');
    if (cartCount) new MutationObserver(updateThreshold).observe(cartCount, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
